import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import About from './components/About';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 py-5 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/7651ebf1-4b0a-46d2-8ef3-702513d8925c.png" 
              alt="Escobar Marketing Logo" 
              className="h-12 w-auto object-contain"
            />
          </div>
          
          <div className="hidden md:flex items-center gap-10">
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('audit-form')}
            className="bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Free Audit →
          </button>
        </div>
      </nav>

      <Hero />
      <Services />
      <WhyChooseUs />
      <About />
      <CallToAction />
      <Footer />
    </div>
  );
}
